import { useIntl } from 'react-intl';
import styles from './StripeApplePayButton.module.scss';

type Props = {
  submitting: boolean;
};

/** Stripe only loads the Apple Pay SDK for express checkout in the iframe so this is a copy of apple-pay-button that works without the SDK */
export default function StripeApplePayButton({ submitting }: Props) {
  const intl = useIntl();

  return (
    <button
      aria-label={`${intl.formatMessage({ defaultMessage: 'Continue with' })} Apple Pay`}
      className={styles.button}
      disabled={submitting}
      type="submit"
    >
      <span aria-hidden="true">{intl.formatMessage({ defaultMessage: 'Continue with' })}&nbsp;</span>
      <span aria-hidden="true" className={styles.logo}></span>
    </button>
  );
}
